// src/app/material.module.ts
import { NgModule } from '@angular/core';

// Forms básicos
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule }      from '@angular/material/input';
import { MatSelectModule }     from '@angular/material/select';
import { MatCheckboxModule }   from '@angular/material/checkbox';
import { MatRadioModule }      from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

// Botões / ícones / cards / tooltip
import { MatButtonModule }   from '@angular/material/button';
import { MatIconModule }     from '@angular/material/icon';
import { MatCardModule }     from '@angular/material/card';
import { MatTooltipModule }  from '@angular/material/tooltip';

// Datas
import { MatDatepickerModule }   from '@angular/material/datepicker';
import { MatNativeDateModule }   from '@angular/material/core'; // adapter nativo

// Tabelas / listas
import { MatTableModule }     from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule }      from '@angular/material/sort';
import { MatListModule }      from '@angular/material/list';
import { MatChipsModule }     from '@angular/material/chips';

// Dialog / menu / overlay
import { MatDialogModule }    from '@angular/material/dialog';
import { MatMenuModule }      from '@angular/material/menu';
import { MatSnackBarModule }  from '@angular/material/snack-bar';
import { MatDividerModule }   from '@angular/material/divider';

// Progress/feedback
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  exports: [
    // Forms
    MatFormFieldModule, MatInputModule, MatSelectModule,
    MatCheckboxModule, MatRadioModule, MatSlideToggleModule,

    // Básicos / layout
    MatButtonModule, MatIconModule, MatCardModule, MatTooltipModule,

    // Datas
    MatDatepickerModule, MatNativeDateModule,

    // Listas / tabelas
    MatTableModule, MatPaginatorModule, MatSortModule, MatListModule, MatChipsModule,

    // Overlays
    MatDialogModule, MatMenuModule, MatSnackBarModule, MatDividerModule,

    // Feedback
    MatProgressBarModule, MatProgressSpinnerModule,
  ]
})
export class MaterialModule {}
